import React from 'react'

const CTA = () => {
    return (
        <div className='cta'>
        <a href="https://read.cv/aslam" className='btn' target="_blank" rel="noreferrer">Read CV</a>
            <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
    )
}

export default CTA